import "./globals.css";
import { AuthProvider } from "@/hooks/useAuth";
import { ToastProvider } from "@/context/ToastContext";
import { SettingsProvider } from "@/context/SettingsContext";
import { ConnectionProvider } from "@/context/ConnectionContext";
import { DynamicManifest } from "./components/DynamicManifest";
import { DynamicFavicon } from "./components/DynamicFavicon";
import { ServiceWorkerRegister } from "./components/ServiceWorkerRegister";
import { PWAInstallPrompt } from "./components/PWAInstallPrompt";
import { NetworkStatus } from "@/components/NetworkStatus";
import { ClientWrapper } from "./components/ClientWrapper";

export default function RootLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <ConnectionProvider>
      <SettingsProvider>
        <ToastProvider>
          <AuthProvider>
            <ClientWrapper>
              <PWAInstallPrompt />
              <DynamicManifest />
              <DynamicFavicon />
              <ServiceWorkerRegister />
              <NetworkStatus />
              {children}
            </ClientWrapper>
          </AuthProvider>
        </ToastProvider>
      </SettingsProvider>
    </ConnectionProvider>
  );
}
